import React, { Component } from "react";
import styles from "./StickyTableHeader.local.scss";
import { getScrollbarWidth, isMacOS } from "Utils";
import { Tooltip } from "antd";
import _ from "i18n";

class StickyTableHeader extends Component {
  render() {
    const { columns, benchmark } = this.props;
    let scrollBarWidth = getScrollbarWidth();
    return columns && columns.length > 0 ? (
      <div
        className={styles.sticky_table_header}
        style={{
          paddingRight: !isMacOS() ? scrollBarWidth : 0,
          paddingTop: 0,
          paddingLeft: 0,
          paddingBottom: 0
        }}
      >
        {columns.map(col => (
          <span style={{ flexBasis: col.basis, flexGrow: col.grow }}>
            {col.name.toUpperCase()}
            {col.name.search("Benchmark") !== -1 ? (
              <Tooltip
                placement="bottom"
                title={
                  <div style={{ textAlign: "justify" }}>
                    <div>
                      {_("La valeur du benchmark utilisé est de ")}
                      {benchmark ? benchmark : 70}.
                      {_(
                        " Vous pouvez la modifier en tout moment dans la page de parametrage."
                      )}
                    </div>
                  </div>
                }
              >
                <img
                  data-for="info__undefined"
                  data-tip=""
                  className={styles.info_icon}
                  src="/img/icons/info_gris.svg"
                  alt=""
                  currentitem="false"
                />
              </Tooltip>
            ) : (
              ""
            )}
          </span>
        ))}
      </div>
    ) : (
      <div>No columns provided</div>
    );
  }
}

export default StickyTableHeader;



// WEBPACK FOOTER //
// ./src/components/Common/StickyTableHeader/StickyTableHeader.js